import UpdateBulkEmployeesSalaryContainer from './UpdateBulkEmployeesSalaryContainer';
import ApproveCommissionPaymentContainer from './ApproveCommissionPaymentContainer';
import TerminateBulkEmployeesContainer from './TerminateBulkEmployeesContainer';
import UploadCommissionSheetContainer from './UploadCommissionSheetContainer';
import SpecificEmployeeContainer from './SpecificEmployeeContainer';
import AddBulkEmployeesContainer from './AddBulkEmployeesContainer';
import ViewDepartmentsContainer from './ViewDepartmentsContainer';
import ViewEmployeesContainer from './ViewEmployeesContainer';
import AddEmployeesContainer from './AddEmployeesContainer';
import EditEmployeeContainer from './EditEmployeeContainer';
import ViewGroupsContainer from './ViewGroupsContainer';
import EmployeesContainer from './EmployeesContainer';
import AddLoanContainer from './AddLoanContainer';
import CommisionTableContainer from './CommisionTableContainer';

export {
	EmployeesContainer,
	AddLoanContainer,
	ViewEmployeesContainer,
	AddEmployeesContainer,
	EditEmployeeContainer,
	SpecificEmployeeContainer,
	AddBulkEmployeesContainer,
	TerminateBulkEmployeesContainer,
	ViewGroupsContainer,
	ViewDepartmentsContainer,
	UpdateBulkEmployeesSalaryContainer,
	UploadCommissionSheetContainer,
	ApproveCommissionPaymentContainer,
	CommisionTableContainer,
};
